<template>
  <div class="custom-control custom-switch build-tray-clear-button">
    <input :disabled="processing" type="checkbox" :checked="isBuildTrayIsClear" @click="handleClick" class="custom-control-input" :id="checkboxId" />
    <label class="custom-control-label" :class="{ 'text-muted' : !isBuildTrayIsClear }" :for="checkboxId">{{$t('printers.item.buildTrayIsClear')}}</label>
  </div>
</template>

<script>
  import {mapActions} from 'vuex';
  import PrinterMixin from '@/mixins/printer.js';

  export default {
    name: 'printer-build-tray-is-clear-button',
    props: ['printer'],
    mixins: [PrinterMixin],
    data() {
      return {
        processing: false
      }
    },
    computed: {
      checkboxId() {
        return 'build-tray-checkbox-' + this.printer.printer_id;
      },
      isBuildTrayIsClear() {
        return this.buildTrayIsClear(this.printer);
      },
    },
    methods: {
      ...mapActions(['clearBuildTray']),

      handleClick(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        this.processing = true;
        this.clearBuildTray({printerId: this.printer.printer_id, isClear: !this.isBuildTrayIsClear}).then(({data}) => {
          this.processing = false;
          if (!data.result) {
            this.msgBoxOk(data.message, {title: this.$t('printers.item.clearBuildTrayErrorTitle')});
          }
        }).catch(() => {
          this.processing = false;
          this.msgBoxOk(this.$t('printers.item.clearBuildTrayError'), {title: this.$t('printers.item.clearBuildTrayErrorTitle')});
        });
      }
    }
  }
</script>

<style lang="scss">
  .build-tray-clear-button {
    margin-right: 24px;
    cursor: pointer;

    input, label {
      cursor: pointer;
    }

  }
</style>